import React, { useEffect, useState } from "react";

import Combobox from "/component/base/Combobox";
import { MapPin } from "/component/base/Icon";
import { AWSAutocompletePrediction, formatAddress } from "/geoservice";
import { useFPPlaceAutocomplete, usePlaceDetails } from "/hook";

import { Props } from "./AddressCombobox.types";

const AddressCombobox = ({
  onSelectAddress,
  onChangeText: onChangeTextProp,
  formattedAddress,
  hasError,
  showIcon = true,
  ...otherProps
}: Props) => {
  const [input, setInput] = useState(formattedAddress || "");
  const [selectedPlaceId, setSelectedPlaceId] = useState<string>();

  const { data: predictions } = useFPPlaceAutocomplete({ input });
  const { data: placeDetails } = usePlaceDetails(selectedPlaceId ?? "");

  useEffect(() => {
    if (placeDetails) {
      onSelectAddress?.(formatAddress(placeDetails));
    }
  }, [placeDetails]);

  useEffect(() => {
    if (formattedAddress) {
      setInput(formattedAddress);
    }
  }, [formattedAddress]);

  const filteredPredictions = predictions?.filter(({ PlaceId }) => !!PlaceId);

  const handleSelectItem = (item?: AWSAutocompletePrediction | null) => {
    if (onSelectAddress && item?.PlaceId) {
      setSelectedPlaceId(item?.PlaceId);
    }
  };

  const handleChange = (changedText?: string) => {
    setInput(changedText || "");
    if (onChangeTextProp) {
      onChangeTextProp(changedText || "");
    }
  };

  return (
    <Combobox
      {...otherProps}
      before={showIcon ? <MapPin /> : null}
      itemToString={(item) => item?.Address?.Label || ""}
      items={filteredPredictions}
      onChangeSelectedItem={handleSelectItem}
      onChangeText={handleChange}
      inputValue={input}
      hasError={hasError}
    />
  );
};

export default AddressCombobox;
